import LineChartMultiSeries from './LineChartMultiSeries.json';
import LineChartMultiSeriesCompact from './LineChartMultiSeriesCompact.json';
import AreaChartMultiSeries from './AreaChartMultiSeries.json';
import AreaChartMultiSeriesCompact from './AreaChartMultiSeriesCompact.json';
import AreaChartMultiSeriesLegendBottom from './AreaChartMultiSeriesLegendBottom.json';
import AreaChartMultiSeriesLegendRight from './AreaChartMultiSeriesLegendRight.json';
import LogScaleChart from './LogScaleChart.json';
import CartesianColumnChart from './CartesianColumnChart.json';
import CartesianStackedColumnChart from './CartesianStackedColumnChart.json';

export default [
  LineChartMultiSeries,
  LineChartMultiSeriesCompact,
  AreaChartMultiSeries,
  AreaChartMultiSeriesCompact,
  AreaChartMultiSeriesLegendBottom,
  AreaChartMultiSeriesLegendRight,
  LogScaleChart,
  CartesianColumnChart,
  CartesianStackedColumnChart,
];
